import React, { useState } from 'react';
import Modal from '../../../_ui/Modal/Modal';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import withTranslation from '../../../components/_hoc/withTranslation';
import Form from '../../../_ui/Form/Form';
import Row from '../../../_ui/Row';
import Button from '../../../_ui/Button/Button';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  completePositiveSupplierChangeLocation,
  statementModule
} from '../StatementDucks';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

function CompletePositiveSupplierChangeLocation({
  onClose,
  id,
  completePositiveSupplierChangeLocation,
  t,
  loading
}) {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');

  const handleFileChange = e => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFileName(selectedFile.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result.split(',')[1];
        setFile(base64);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = () => {
    if (file) {
      completePositiveSupplierChangeLocation(id, { protocol: file }, onClose);
    }
  };

  return (
    <Modal
      open
      title={t('statement_completePositiveSupplierTitle')}
      onClose={onClose}
      maxWidth="sm"
    >
      <Form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Row label={t('statement_attachFile')} className="flex items-start">
            <input
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              className="display-none"
              id="contained-button-file"
              type="file"
              onChange={handleFileChange}
            />
            <label htmlFor="contained-button-file">
              <Button
                component="span"
                color="primary"
                text={t('statement_attachFile')}
                icon={<AttachFileIcon className="mr1" />}
              />
            </label>
            {file && (
              <div className="flex items-center ml2">
                <span className="mr1">{fileName}</span>
                <IconButton
                  onClick={() => {
                    setFile(null);
                    setFileName('');
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            )}
          </Row>
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            color="primary"
            text={t('statement_send')}
            loading={loading}
            disabled={!file}
          />
        </DialogActions>
      </Form>
    </Modal>
  );
}

export default compose(
  withTranslation,
  connect(
    state => ({
      loading: state[statementModule].loadingCompletePositiveSupplierChangeLocation
    }),
    { completePositiveSupplierChangeLocation }
  )
)(CompletePositiveSupplierChangeLocation);
